export const CYCLE_NAME_MAX_LENGTH = 280;
export const REQUIRED = "This is a required field";

export const AUTOMATION_TYPES = ["oneTime", "recurring"] as const;
export type AutomationType = (typeof AUTOMATION_TYPES)[number];

export const AUTOMATION_TYPE_OPTIONS = [
	{
		label: "Match Subjects on Review Cycle Start Date",
		subtext: "PerformYard will assign reviews to any qualifying subjects on the Review Cycle start date and time.",
		value: "oneTime",
	},
	{
		label: "Add Subjects on a Rolling Basis",
		subtext:
			"Starting on your Review Cycle start date and time, PerformYard will continuously monitor for new subjects to assign to this review cycle. This occurs every day at midnight until the cycle is closed, the automation is disabled, or the Review Cycle end date and time is reached.",
		value: "recurring",
	},
] satisfies { label: string; subtext: string; value: AutomationType }[];

export const LOCK_REVIEWS_LABEL = "Lock Reviews from Non-Admins";
export const LOCK_REVIEWS_INFO =
	"Selecting this option will only allow admins to make process changes such as adding forms, changing authors/signers, modifying visibility, and updating due dates for individual reviews.";
